import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { FiFileText, FiMail } from "react-icons/fi";
import { SalesEmailLink } from "./SignupLinkCard";

const BRAND_COLOR = "#009baa";
const TEXT_STYLE = { color: "#858c9c", fontSize: "14px", margin: 0 };

const PanelCard = ({
  icon,
  title,
  body,
  note,
  footer,
}: {
  icon: React.ReactNode;
  title: string;
  body: React.ReactNode;
  note?: React.ReactNode;
  footer: React.ReactNode;
}) => (
  // the global .card margin would stretch an h-100 card, the row's gutter spaces them instead
  <Card className="h-100" style={{ marginBottom: 0 }}>
    <Card.Body className="d-flex flex-column" style={{ padding: 24, gap: 12 }}>
      <div className="d-flex align-items-center" style={{ gap: 12 }}>
        {icon}
        <Card.Title style={{ color: "#0a2540", margin: 0 }}>{title}</Card.Title>
      </div>
      <p style={TEXT_STYLE}>{body}</p>
      {note && <p style={TEXT_STYLE}>{note}</p>}
      <p style={TEXT_STYLE}>{footer}</p>
    </Card.Body>
  </Card>
);

// shown at signup without a signup link, where employer accounts can only be created from an order
const SignupSalesPanel = (): React.JSX.Element => (
  <div className="step-container is-active">
    <section className="page-title-wrap">
      <article className="text-cell">
        <p className="page-title">Interested in Icon?</p>
        <p className="page-subtext">
          Icon makes it simple to offer your team a retirement savings plan.
          Talk to our sales team to find the right plan for your business, and
          we&#39;ll send you a link to set up your account.
        </p>
      </article>
    </section>
    {/* margin on the g-4 Row itself would replace its gutter offset */}
    <div style={{ marginTop: 4 }}>
      <Row className="g-4">
        <Col md={6}>
          <PanelCard
            icon={<FiMail size={28} color={BRAND_COLOR} />}
            title="Talk to our sales team"
            body="We'll walk you through plans and pricing, and answer any questions about getting started."
            footer={
              <>
                Email us at <SalesEmailLink />
              </>
            }
          />
        </Col>
        <Col md={6}>
          <PanelCard
            icon={<FiFileText size={28} color={BRAND_COLOR} />}
            title="Already placed an order?"
            body="Your signup link is in the order email from Icon. Open it from that email to create your company account."
            note={
              <>
                Signing up through a payroll partner?{" "}
                <a className="link" href="/partner" style={{ paddingLeft: 0 }}>
                  Sign up with your partner referral code
                </a>
              </>
            }
            footer={
              <>
                Having trouble finding your link? Contact <SalesEmailLink />
              </>
            }
          />
        </Col>
      </Row>
    </div>
  </div>
);

export default SignupSalesPanel;
